import React from 'react'

import Icon from '../data/icon.png';
const Entete = () => {
    return (
        <div className="flex justify-between gap-3">
            <div className="flex flex-col gap-3">
                <h1 className='font-bold'>Complexe privé El Messar</h1>
                <h1>Jardin-Primaire-Collège-Secondaire</h1>
                <h3 className="text-sm">Tel: 41014001-38327532-37203322-36424557</h3>
            </div>
            <img className="mx-auto h-28 w-auto" src={Icon} alt="Your Company" />
            <div className="flex flex-col text-right gap-3">
                <h1 className='font-bold'> مـجــمـــع مدارس المسار الخاصة </h1>
                <h1> روضة - ابتدائية - إعدادية - ثانوية </h1>
                <h3 className="text-sm"> 41014001-38327532-37203322-36424557: الهاتف</h3>
            </div>
        </div>
    )
}

export default Entete